/* global ViewController, WebView */
var docShareController = new ViewController({
    directory : "views/public",
    name: "docSearchShare",
    container: "main",
    route: "docs-share"
}) ;

docShareController.prepareDataOnEnter = function(token, callback){
    var data = {
        token: token,
    } ;
    this.api.public.getShareSettings(function(err, settings){
        if(err) {return callback(err) ;}
        this.api.public.getSharedSearchDocuments(token, function(err, share){
            if(err){
                if(err === "EXPIRED"){
                    return callback(null, { expired: true }) ;
                }
                if(err === "NOT_FOUND"){
                    return callback(null, { notfound: true }) ;
                }
                if(err === "NEED_PASSWORD"){
                    var viewChange = new WebView("views/public", "docSharePasswordPopup") ;
                    viewChange.openInPopup({
                        title: '',
                        aboveAll: true
                    })  ;
                    viewChange.on("validate",function(){
                        var passData = viewChange.getData() ;
                        
                        viewChange.close() ;
                        this.api.public.getSharedSearchDocuments(token, passData.share_password, function(err, share){
                            if(err){
                                if(err === "EXPIRED"){
                                    return callback(null, { expired: true }) ;
                                }
                                if(err === "WRONG_PASSWORD"){
                                    return callback(null, { wrongpassword: true }) ;
                                }
                                return callback(err) ;
                            }
                            data.name = share.name ;
                            data.docs = share.docs ;
                            data.password = passData.share_password ;
                            if(settings.attach){
                                data.hasCustomBg = true ;
                            }
                            callback(null, data) ;
                        }.bind(this)) ;
                    }.bind(this)) ;
                    return;
                }
                return callback(err) ;
            }
            data.name = share.name ;
            data.docs = share.docs ;
            if(settings.attach){
                data.hasCustomBg = true ;
            }
            callback(null, data) ;
        }.bind(this)) ;
    }.bind(this)) ;

};

docShareController.onDownload = function(ev){
    this.view.longTask(function(done){
        this.api.public.downloadSharedDocumentFromSearch(this.data.token,
            ev.data.data.id,
            this.data.password
        , done) ;
    }.bind(this)) ;
} ;


module.exports = docShareController ;